import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {UserProfileService} from '@services/user-profile.service';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrl: './header.component.scss',
    standalone: false
})
export class HeaderComponent implements OnInit {

  private isCustomerMenu = false;
  private isMenuNav = false;
  private urlActive: string;

  constructor(private router: Router,
              private manageProfile: UserProfileService) {
  }

  ngOnInit() {
    this.isCustomerMenu = this.manageProfile.isCustomerOrRelationshipProfile();
    this.isMenuNav = this.manageProfile.isBackOffice() || this.manageProfile.isPartner();
    this.urlActive = this.router.routerState.snapshot.url;
  }

  private isURLBackoffice(): boolean {
    return this.urlActive && (this.urlActive.split('/').includes('backoffice'));
  }

  private isURLPartner(): boolean {
    return this.urlActive && (this.urlActive.split('/').includes('parceiro'));
  }

  handleCustomerHeader() {
    return this.isCustomerMenu || (this.isMenuNav && !this.isURLBackoffice() && !this.isURLPartner());
  }

  handleMenuNavHeader() {
    return this.isMenuNav && (this.isURLBackoffice() || this.isURLPartner());
  }
}
